// imports
import Carousel from 'minsky-kit/js/components/Carousel';
import { strToCssClass } from 'minsky-kit/js/utils/css';
import _merge from 'lodash/merge';

// private statics

// class definition
export default class WCarousel extends Carousel {
    // constructor
    constructor (args = {}, objectName = 'WCarousel') {
        args.debug = args.debug || false;

        args.settings = _merge({}, {
            spaceBetween: 40,
        }, args.settings);

        const originalObjectName = objectName;
        objectName = 'Carousel';

        // class management
        args.$el.classList.add(strToCssClass(objectName, null, originalObjectName.replace('Carousel', '')));

        // super
        super(args, objectName);

        // drimage
        if (Drupal.drimage) {
            this.$el.querySelectorAll('.js-delay-drimage').forEach(($item) => {
                $item.classList.remove('js-delay-drimage');
                Drupal.drimage.init($item);
            });
        }

        // setup
        this.navigation = true;
        this.pagination = false;
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
